import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/api";
import { TrackRow } from "@/components/TrackViews";
import { trackCoverUrl } from "@/context/PlayerContext";
import BioView from "@/components/BioView";

export default function Artist() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/artists/${id}`).then(r => setData(r.data)).catch(() => setData({ profile: null, tracks: [] }));
  }, [id]);

  if (!data) return <div className="player-space px-4 md:px-10 py-12 font-mono-ui text-sm text-neutral-500">Loading...</div>;
  if (!data.profile) return <div className="player-space px-4 md:px-10 py-12 font-editorial text-2xl">Artist not found.</div>;

  const topCover = data.tracks[0] && trackCoverUrl(data.tracks[0]);

  return (
    <div className="player-space">
      <section className="grid grid-cols-1 lg:grid-cols-12 gap-8 px-4 md:px-10 py-12 border-b border-neutral-900">
        <div className="lg:col-span-5 aspect-square border border-neutral-900 overflow-hidden bg-neutral-950">
          {data.profile.avatar_url ? (
            <img src={data.profile.avatar_url} alt={data.profile.display_name} className="w-full h-full object-cover" data-testid="artist-photo" />
          ) : topCover ? (
            <img src={topCover} alt={data.profile.display_name} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center font-display text-9xl text-neutral-800">
              {data.profile.display_name[0]}
            </div>
          )}
        </div>
        <div className="lg:col-span-7">
          <div className="font-mono-ui text-[11px] uppercase tracking-[0.3em] text-red-500">Artist</div>
          <h1 className="font-display text-6xl sm:text-7xl font-black tracking-tighter uppercase leading-[0.9] mt-4" data-testid="artist-name">
            {data.profile.display_name}
          </h1>
          {data.profile.genre && (
            <div className="font-mono-ui text-xs uppercase tracking-widest text-neutral-400 mt-6">{data.profile.genre}</div>
          )}
          {data.profile.bio && (
            <BioView text={data.profile.bio} testId="artist-bio"
                     className="font-editorial text-xl text-stone-300 mt-8 leading-snug max-w-2xl" />
          )}
          <div className="flex gap-10 mt-10 font-mono-ui text-xs uppercase tracking-widest">
            <div>
              <div className="text-neutral-500">Tracks</div>
              <div className="text-white text-2xl font-display font-black mt-1">{data.tracks.length}</div>
            </div>
            <div>
              <div className="text-neutral-500">Followers</div>
              <div className="text-white text-2xl font-display font-black mt-1">{data.profile.followers ?? 0}</div>
            </div>
            <div>
              <div className="text-neutral-500">Plays</div>
              <div className="text-white text-2xl font-display font-black mt-1">
                {data.tracks.reduce((s, t) => s + (t.plays || 0), 0).toLocaleString()}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-10 py-12">
        <h2 className="font-display text-3xl font-bold tracking-tight mb-6">Discography</h2>
        <div className="hard-card">
          {data.tracks.length === 0 ? (
            <div className="p-8 font-editorial text-xl text-neutral-500">No releases yet.</div>
          ) : data.tracks.map((t, i) => <TrackRow key={t.id} track={t} index={i} list={data.tracks} />)}
        </div>
      </section>
    </div>
  );
}
